import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Text,
  Input,
  VStack,
  HStack,
  Image,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  FaUser,
  FaPhone,
  FaLock,
  FaBook,
  FaVenusMars,
  FaRegFileAlt,
} from "react-icons/fa";
import logo from "../../assets/logo.png"
import {
  signupUserAction,
  governoratesAction,
} from "../../modules/auth/Actions";
import { getAllSubjectsRequest } from "../../modules/admin-modules/subjects/Actions";
import PublicLayout from "../public/Layout/layout";
const SignupForm = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const subjects = useSelector((state) => state.subjects.subjects);
  const governorates = useSelector((state) => state.auth.governorates);
  const navigate = useNavigate();
  const [inputType, setInputType] = useState("password");

  const palette = {
    primary: "#7A1422",
    secondary: "#8B1828",
    tertiary: "#D6CEC0",
    neutral: "#F3ECE6",
    ink: "#2D2A26",
    soft: "#6B5A5A",
  };

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const governoratesOptions = Array.isArray(governorates)
    ? governorates.map((data) => {
        return { value: data.id, label: data.name };
      })
    : [];
  
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" }
  ];
  
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "rgba(255, 255, 255, 0.72)",
      color: palette.ink,
      borderRadius: "12px",
      border: `1px solid ${palette.tertiary}`,
      boxShadow: "0 4px 15px rgba(74, 15, 31, 0.08)",
      backdropFilter: "blur(12px)",
      "&:hover": {
        borderColor: palette.primary,
      },
      "&:focus": {
        borderColor: palette.primary,
        boxShadow: "0 0 0 3px rgba(122, 20, 34, 0.12)",
      },
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      color: isSelected ? palette.neutral : palette.ink,
      backgroundColor: isSelected
        ? palette.secondary
        : isFocused
          ? palette.neutral
          : "white",
      "&:hover": {
        backgroundColor: isSelected ? palette.secondary : palette.neutral,
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      color: palette.soft,
    }),
  };
  
  useEffect(() => {
    dispatch(getAllSubjectsRequest());
    dispatch(governoratesAction());
  }, []);

  const validateUserName = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }

    return error;
  };

  const validateConfirmPassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateParentPhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateSubjectId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  
  const validateGender = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateGovernorateId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  return (
    <PublicLayout color="main_1" bg="white" register={false}>
      <Flex
        flexDirection="column"
        alignItems="center"
        my="50px"
        w="100%"
        h="100%"
      >
        <Formik
          initialValues={{
            name: "",
            phone: "",
            password: "",
            faculty_id: "",
            year_id: "",
            profile_url: "",
            profile_url2: "",
            parent_phone: "",
            subject_id: "",
            gender: "",
            governorate_id: "",
            school: "",
            city: "",
            terms: false,
          }}
          onSubmit={(values) => {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("phone", values.phone);
            formData.append("password", values.password);
            formData.append(
              "password_confirmation",
              values.password_confirmation
            );
            formData.append("parent_phone", values.parent_phone);
            formData.append("subject_id", values.subject_id);
            formData.append("student_group_id", 1);
            formData.append("gender", values.gender);
            formData.append("governorate_id", values.governorate_id);
            formData.append("school", values.school);
            formData.append("city", values.city);

            dispatch(
              signupUserAction(formData, () => {
                navigate("/login");
              })
            );
            
          }}
        >
          {({ setValues, errors, touched, values, setFieldValue }) => (
            <Form
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                w={{ base: "95%", md: "500px" }}
                maxW="500px"
                p={{ base: 6, md: 8 }}
                borderRadius="2xl"
                borderWidth="1px"
                borderColor={palette.tertiary}
                bg="rgba(255, 255, 255, 0.72)"
                backdropFilter="blur(12px)"
                boxShadow="0 14px 30px rgba(74, 15, 31, 0.12)"
              >
                <VStack spacing={8} align="stretch">
                  <VStack spacing={4} align="center">
                    <Image
                      src={logo}
                      alt="logo"
                      w="120px"
                      h="auto"
                    />
                    <Heading 
                      textAlign="center" 
                      fontSize={{ base: "28px", md: "32px" }}
                      fontWeight="800"
                      color={palette.secondary}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      Create an account
                    </Heading>
                    <Text 
                      textAlign="center" 
                      color={palette.soft}
                      fontSize="16px"
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      Fill the details below to create your account
                    </Text>
                  </VStack>

                  {/* Name Field */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="name"
                      color={palette.secondary}
                      fontSize="18px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <HStack spacing={2}>
                        <FaUser color={palette.primary} />
                        <Text>Full name</Text>
                      </HStack>
                    </FormLabel>

                    <Field
                      as={Input}
                      name="name"
                      validate={validateUserName}
                      placeholder="Enter your full name"
                      size="lg"
                      borderRadius="xl"
                      border="1px solid"
                      borderColor={palette.tertiary}
                      bg="rgba(255, 255, 255, 0.72)"
                      backdropFilter="blur(12px)"
                      _focus={{
                        borderColor: palette.primary,
                        boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                      }}
                      _hover={{
                        borderColor: palette.primary,
                      }}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    />
                    {errors.name && touched.name && (
                      <Text color="red.500" fontSize="sm" mt={2} fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif">
                        {errors.name}
                      </Text>
                    )}
                  </Box>

                  {/* Country and City */}
                  <Flex
                    w="100%"
                    gap={6}
                    flexDirection="column"
                    alignItems="stretch"
                  >
                    <Box w="100%">
                      <FormLabel
                        htmlFor="governorate_id"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaRegFileAlt color={palette.primary} />
                          <Text>Country</Text>
                        </HStack>
                      </FormLabel>

                      <Select
                        options={governoratesOptions}
                        onChange={(data) => {
                          setFieldValue("governorate_id", data?.value);
                        }}
                        styles={colourStyles}
                        placeholder="Country"
                        validate={validateGovernorateId}
                      />
                      {errors.governorate_id && touched.governorate_id && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                        >
                          {errors.governorate_id}
                        </Text>
                      )}
                    </Box>

                    <Box w="100%">
                      <FormLabel
                        htmlFor="city"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <Text>City</Text>
                      </FormLabel>

                      <Field
                        as={Input}
                        name="city"
                        type="text"
                        placeholder="Enter your city"
                        size="lg"
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={palette.tertiary}
                        bg="rgba(255, 255, 255, 0.72)"
                        backdropFilter="blur(12px)"
                        _focus={{
                          borderColor: palette.primary,
                          boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                        }}
                        _hover={{
                          borderColor: palette.primary,
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />
                    </Box>
                  </Flex>

                  {/* School */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="school"
                      color={palette.secondary}
                      fontSize="18px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <Text>School</Text>
                    </FormLabel>

                    <Field
                      as={Input}
                      name="school"
                      type="text"
                      placeholder="Enter your school"
                      size="lg"
                      borderRadius="xl"
                      border="1px solid"
                      borderColor={palette.tertiary}
                      bg="rgba(255, 255, 255, 0.72)"
                      backdropFilter="blur(12px)"
                      _focus={{
                        borderColor: palette.primary,
                        boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                      }}
                      _hover={{
                        borderColor: palette.primary,
                      }}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    />
                  </Box>

                  {/* Phone and Parent */}
                  <Flex
                    w="100%"
                    gap={6}
                    flexDirection="column"
                    alignItems="stretch"
                  >
                    <Box w="100%">
                      <FormLabel
                        htmlFor="phone"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaPhone color={palette.primary} />
                          <Text>Phone number</Text>
                        </HStack>
                      </FormLabel>
                      <Text
                        fontSize="12px"
                        color={palette.soft}
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        If the number is Gulf-based, add 00 before it (e.g. 009xxxx). For Egyptian numbers, enter the full number as-is (e.g. 012345).
                      </Text>

                      <Field
                        as={Input}
                        name="phone"
                        type="text"
                        validate={validatePhone}
                        placeholder="Enter your phone number"
                        size="lg"
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={palette.tertiary}
                        bg="rgba(255, 255, 255, 0.72)"
                        backdropFilter="blur(12px)"
                        _focus={{
                          borderColor: palette.primary,
                          boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                        }}
                        _hover={{
                          borderColor: palette.primary,
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />
                      {errors.phone && touched.phone && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                        >
                          {errors.phone}
                        </Text>
                      )}
                    </Box>

                    <Box w="100%">
                      <FormLabel
                        htmlFor="parent_phone"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaPhone color={palette.primary} />
                          <Text>Parent phone</Text>
                        </HStack>
                      </FormLabel>
                      <Text
                        fontSize="12px"
                        color={palette.soft}
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        If the number is Gulf-based, add 00 before it (e.g. 009xxxx). For Egyptian numbers, enter the full number as-is (e.g. 012345).
                      </Text>

                      <Field
                        as={Input}
                        name="parent_phone"
                        type="text"
                        validate={validateParentPhone}
                        placeholder="Enter parent phone number"
                        size="lg"
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={palette.tertiary}
                        bg="rgba(255, 255, 255, 0.72)"
                        backdropFilter="blur(12px)"
                        _focus={{
                          borderColor: palette.primary,
                          boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                        }}
                        _hover={{
                          borderColor: palette.primary,
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />
                      {errors.parent_phone && touched.parent_phone && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                        >
                          {errors.parent_phone}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                  {/* Gender */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="gender"
                      color={palette.secondary}
                      fontSize="18px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <HStack spacing={2}>
                        <FaVenusMars color={palette.primary} />
                        <Text>Gender</Text>
                      </HStack>
                    </FormLabel>

                    <Select
                      options={genderOptions}
                      onChange={(data) => {
                        setFieldValue("gender", data.value);
                      }}
                      styles={colourStyles}
                      placeholder="Choose gender"
                      validate={validateGender}
                    />
                    {errors.gender && touched.gender && (
                      <Text
                        color="red.500"
                        fontSize="sm"
                        mt={2}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        {errors.gender}
                      </Text>
                    )}
                  </Box>

                  {/* Subject */}
                  <Box w="100%">
                    <FormLabel
                      htmlFor="subject_id"
                      color={palette.secondary}
                      fontSize="18px"
                      fontWeight="700"
                      mb={3}
                      fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                    >
                      <HStack spacing={2}>
                        <FaBook color={palette.primary} />
                        <Text>Subject</Text>
                      </HStack>
                    </FormLabel>

                    <Select
                      options={subjectsOptions}
                      onChange={(data) => {
                        setFieldValue("subject_id", data.value);
                      }}
                      styles={colourStyles}
                      placeholder="Choose a subject"
                      validate={validateSubjectId}
                    />
                    {errors.subject_id && touched.subject_id && (
                      <Text
                        color="red.500"
                        fontSize="sm"
                        mt={2}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        {errors.subject_id}
                      </Text>
                    )}
                  </Box>

                  {/* Password */}
                  <Flex w="100%" gap={6} flexDirection="column">
                    <Box w="100%" position="relative">
                      <FormLabel
                        htmlFor="password"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaLock color={palette.primary} />
                          <Text>Password</Text>
                        </HStack>
                      </FormLabel>

                      <Field
                        as={Input}
                        name="password"
                        validate={validatePassword}
                        type={inputType}
                        placeholder="Enter your password"
                        size="lg"
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={palette.tertiary}
                        bg="rgba(255, 255, 255, 0.72)"
                        backdropFilter="blur(12px)"
                        pr="50px"
                        _focus={{
                          borderColor: palette.primary,
                          boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                        }}
                        _hover={{
                          borderColor: palette.primary,
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />

                      <Icon
                        position="absolute"
                        right="15px"
                        top="50px"
                        fontSize="20px"
                        color={palette.soft}
                        cursor="pointer"
                        _hover={{ color: palette.primary }}
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password && touched.password && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                        >
                          {errors.password}
                        </Text>
                      )}
                    </Box>

                    <Box w="100%" position="relative">
                      <FormLabel
                        htmlFor="password_confirmation"
                        color={palette.secondary}
                        fontSize="18px"
                        fontWeight="700"
                        mb={3}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      >
                        <HStack spacing={2}>
                          <FaLock color={palette.primary} />
                          <Text>Confirm password</Text>
                        </HStack>
                      </FormLabel>

                      <Field
                        as={Input}
                        name="password_confirmation"
                        validate={validateConfirmPassword}
                        type={inputType}
                        placeholder="Re-enter your password"
                        size="lg"
                        borderRadius="xl"
                        border="1px solid"
                        borderColor={palette.tertiary}
                        bg="rgba(255, 255, 255, 0.72)"
                        backdropFilter="blur(12px)"
                        pr="50px"
                        _focus={{
                          borderColor: palette.primary,
                          boxShadow: "0 0 0 3px rgba(106, 30, 30, 0.12)",
                        }}
                        _hover={{
                          borderColor: palette.primary,
                        }}
                        fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                      />

                      <Icon
                        position="absolute"
                        right="15px"
                        top="50px"
                        fontSize="20px"
                        color={palette.soft}
                        cursor="pointer"
                        _hover={{ color: palette.primary }}
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password_confirmation && touched.password_confirmation && (
                        <Text
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                        >
                          {errors.password_confirmation}
                        </Text>
                      )}
                    </Box>
                  </Flex>

                 
                  {/* Submit Button */}
                  <Button
                    type="submit"
                    w="full"
                    p="20px"
                    alignSelf="center"
                    isLoading={isLoading}
                    bg={palette.secondary}
                    color={palette.neutral}
                    borderRadius="xl"
                    fontSize="18px"
                    fontWeight="700"
                    _hover={{
                      bg: palette.primary,
                      transform: "translateY(-2px)",
                      boxShadow: "0 12px 28px rgba(74, 15, 31, 0.25)"
                    }}
                    _active={{ transform: "translateY(0)" }}
                    transition="all 0.3s ease"
                    boxShadow="0 6px 18px rgba(74, 15, 31, 0.16)"
                    fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                  >
                    Create account
                  </Button>

                  {/* Login Link */}
                  <Text 
                    textAlign="center" 
                    mt={6}
                    fontSize="16px"
                    color={palette.soft}
                    fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
                  >
                    Already have an account?{" "}
                    <a
                      href="/login"
                      style={{ 
                        color: palette.primary, 
                        textDecoration: "underline",
                        fontWeight: "700"
                      }}
                    >
                      Login
                    </a>
                  </Text>
                </VStack>
              </Box>
            </Form>
          )}
        </Formik>
      </Flex>
    </PublicLayout>
  );
};

export default SignupForm;
